import { LogLine } from './LogLine';
import { MQTTMessageLogEntryExtra } from './parsers/common/MQTTMessageLogEvent';
import { NetworkRequestOutcome } from './parsers/common/NetworkRequestOutcome';

export interface GenericLogEntryExtra {
  severity?: string;
  module?: string;
  thread?: string;
  fileName?: string;
  fileFunction?: string;
  fileLine?: string;
}

export type NetworkRequestLogEntryKeyValuePairs = { key: string; value: string }[];

export interface NetworkRequestLogEntryExtra {
  requestUniqueIndex: number;
  url?: URL;
  outcome: NetworkRequestOutcome;

  request?: {
    logEntryIndex: number;
    date: Date;
    method?: string;
    query?: NetworkRequestLogEntryKeyValuePairs;
    headers?: NetworkRequestLogEntryKeyValuePairs;
    body?: string;
    bodyJson?: any;
  };

  response?: {
    logEntryIndex: number;
    date: Date;
    httpCode?: number;
    headers?: NetworkRequestLogEntryKeyValuePairs;
    body?: string;
    additionalInfo?: string;
    bodyJson?: any;

    durationSec?: number;
  };
}

export interface LogEntryExtra {
  generic?: GenericLogEntryExtra;
  networkRequest?: NetworkRequestLogEntryExtra;
  mqttMessage?: MQTTMessageLogEntryExtra;
}

export enum LogEntryType {
  Generic,
  ReduxAction,
  NetworkRequest,
  NetworkResponse,
  MQTTMessage,
}

export interface LogEntry {
  index: number;
  entryType: LogEntryType;
  originalLines: LogLine[];
  date: Date;
  secondsSinceFirstLogEntry: number;
  content: string;
  extra: LogEntryExtra;
}
